import { APP_ORIGIN } from "src/config/constants";
import { BusinessMenuI } from "src/types/types";
import clientInstance from "./clientInstance";

export const getGameBusinessMenuList = async (originOverride?: string): Promise<any> => {
  return new Promise((resolve, reject) => {
    clientInstance
      .get("game/business-menu-list", {
        params: {
          origin: originOverride || APP_ORIGIN,
        },
      })
      .then((response) => {
        const filteredList = Array.isArray(response?.data?.data)
          ? response.data.data.map((item: any) => {
              let nMenuName = item?.game_name || item?.group_name;

              const i: BusinessMenuI = {
                ...item,
                menu_name: nMenuName || "",
              };

              if (i.is_casino) i.menu_id = i.group_id;
              else i.menu_id = i.provider_game_id;

              return i;
            })
          : [];

        resolve(filteredList);
      })
      .catch((error) => {
        console.log("🚀 ~ getGameBusinessMenuList ~ error:", error);
        reject(error?.response ?? error);
      });
  });
};

export const getLeaguesBySportId = async (game_id: string) => {
  return new Promise((resolve, reject) => {
    clientInstance
      .get(`league/${game_id}`)
      .then((response) => {
        resolve(Array.isArray(response?.data?.data) ? response.data.data : []);
      })
      .catch((error) => {
        console.error(`Error Fetching Leagues By Sport ID`);
        reject(error);
      });
  });
};

export const getEventsByLeagueId = async (id: string) => {
  return new Promise((resolve, reject) => {
    clientInstance
      .get(`event/league-event/${id}`)
      .then((response) => {
        resolve(Array.isArray(response?.data?.data) ? response.data.data : []);
      })
      .catch((error) => {
        console.error(`Error Fetching Events By League ID`);
        reject(error);
      });
  });
};
